export enum UserRoles {
    Admin = 1,
    DriverUser = 2,
    HoltClerk = 4,
    DAEUser = 5,
    Customer = 11,
    Carrier = 12,
    SuperAdmin = 14
}
